"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkIconGlyph = void 0;
var react_1 = __importDefault(require("react"));
var LinkIconGlyph = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 96 49"
  }, react_1.default.createElement("path", {
    d: "M63.8981 24.4586C63.8981 37.9108 52.8917 48.9172 39.7452 48.9172H24.4586C11.0064 48.9172 0 37.9108 0 24.4586C0 11.0064 11.0064 0 24.4586 0H32.7134C34.8535 0 36.0764 2.75159 34.5478 4.28025C32.7134 6.42038 30.879 8.86625 29.656 11.3121C29.3503 12.2293 28.4331 12.8408 27.2102 12.8408H24.1529C17.7325 12.8408 12.535 18.0382 12.535 24.1529C12.535 30.5733 17.7325 35.7707 24.1529 35.7707H39.4395C45.8599 35.7707 51.0573 30.5733 51.0573 24.1529C51.0573 23.2357 51.0573 22.6242 50.7516 22.0127C50.7516 21.0955 50.7516 20.4841 51.3631 19.8726C52.586 18.6497 54.1146 17.7325 55.949 17.7325H60.8408C62.0637 17.7325 63.2866 18.6497 63.2866 19.8726C63.8981 21.707 63.8981 22.9299 63.8981 24.4586ZM96 24.4586C96 11.0064 84.9936 0 71.5414 0H56.2548C42.8025 0 32.1019 10.7006 32.1019 24.4586C32.1019 25.9873 32.1019 27.2102 32.4076 28.7389C32.7134 29.9618 33.6306 30.879 34.8535 30.879H39.7452C41.5796 30.879 43.414 29.9618 44.3312 28.7389C44.9427 28.1274 45.2484 27.2102 44.9427 26.5987C44.9427 25.9873 44.6369 25.3758 44.6369 24.4586C44.6369 18.0382 49.8344 12.8408 56.2548 12.8408H71.5414C77.9618 12.8408 83.1592 18.0382 83.1592 24.4586C83.1592 30.879 77.9618 35.7707 71.5414 35.7707H68.4841C67.5669 35.7707 66.6497 36.3822 66.0382 37.2994C64.8153 40.051 62.9809 42.1911 61.1465 44.3312C59.9236 46.1656 60.8408 48.9172 63.2866 48.9172H71.8471C84.9936 48.9172 96 37.9108 96 24.4586Z",
    fill: "black"
  }));
};
exports.LinkIconGlyph = LinkIconGlyph;